<script lang="ts">
import { replace } from 'svelte-spa-router'
import { slide } from 'svelte/transition'
import Icon from '@iconify/svelte';

import { _ } from '../i18n.svelte'
import { copyClipbord, isNotTextEmpty } from '../util.svelte'
import MessageCard from '../components/messageCard.svelte';

import HmacMD5 from 'crypto-js/hmac-md5'

type Params = { hash: string, message: string, key: string }
export let params: Params
const paramHash    = params.hash
const paramMessage = params.message
const paramKey     = params.key

const hash = HmacMD5(paramMessage, paramKey).toString();

</script>
<template lang="pug">
main
    section.section-message(transition:slide)
        .container.container-message
            .message-answer__sample__wrapper
                .message-answer__sample-message__text { paramMessage }
                .message-answer__sample-hash__text { hash }
            .message-answer__target-hash__wrapper
                | Target: { paramHash }

    section.section-result(class="{paramHash === hash ? 'correct' : 'wrong'}" transition:slide)
        .container.container-result
            +if("paramHash === hash")
                p.answer-result__message__text ハッシュ値が一致しました！これが宣言したメッセージです。
                +else
                p.answer-result__message__text ハッシュ値が違います。これは宣言したメッセージではありません。
</template>
<style lang="scss">
.section-message {
    .container-message {
        padding: 1.5rem 1rem 3rem;
        .message-answer__sample__wrapper {
            width: 100%;
            max-width: 37rem;
            margin: 1rem auto 0;
            padding: 2rem 4rem;
            border: 1px solid var(--color-border-line);
            border-radius: 10px;
            .message-answer__sample-message__text {
                font-weight: bold;
            }
        }
        .message-answer__target-hash__wrapper {
            font-size: 0.8rem;
            text-align: center;
        }
    }
}
.section-result {
    color: var(--color-white);
    &.correct {
        background-color: var(--color-green);
    }
    &.wrong {
        background-color: var(--color-red);
    }
    .container-result {
        padding: 3rem 0;
        text-align: center;
        .answer-result__message__text {
            font-size: 1rem;
            font-weight: bold;
        }
    }
}
</style>
